import React from 'react';

import cn from 'classnames';

import { Flex, Icon, UiText } from '@shared/ui';
import { IEmployee } from '@widgets/EstimateInformation/model/types/types';

import cls from './AvatarsEmployeeList.module.css';
import { useAvatarsEmployeeList } from '../lib/hooks/useAvatarsEmployeeList';

interface AvatarsEmployeeListProps {
    classes?: string;
    employees: IEmployee[];
    onClick?: () => void;
}

export const AvatarsEmployeeList = ({ classes, employees, onClick }: AvatarsEmployeeListProps) => {
    const { showEmployees, moreEmployees, baseZIndex } = useAvatarsEmployeeList(employees);

    return (
        <Flex className={cn(cls.AvatarsEmployeeList, classes)} onClick={onClick}>
            {showEmployees.map((employee, index) => (
                <div
                    key={employee.id}
                    className={cls.avatarWrapper}
                    style={{ zIndex: baseZIndex - index }}
                >
                    {employee.avatarUrl ? (
                        <img src={employee.avatarUrl} alt="avatar" />
                    ) : (
                        <Icon iconName="profileBigSize" width={28} height={28} />
                    )}
                </div>
            ))}
            {!!moreEmployees.length && (
                <div className={cn(cls.avatarWrapper, cls.more)} style={{ zIndex: baseZIndex - 5 }}>
                    <UiText variant="caption">+{moreEmployees.length}</UiText>
                </div>
            )}
        </Flex>
    );
};
